module.exports = __webpack_public_path__ + "dc8db1e70998ec681255cf035eb3aff5.svg";